export default __webpack_public_path__ + "static/media/tt2.9918e693.png";